










import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class Photoroll extends Vue {
  @Prop({ default: '' }) imageSet!: string;

  private imageDict: { [key: string]: string[] } = {
    memories: [
      '2014-05-22',
      '2015-03-22',
      '2015-03-28',
      '2015-05-02',
      '2015-10-24',
      '2015-11-14',
      '2016-03-12',
      '2016-05-28',
      '2016-07-06',
      '2016-10-25',
      '2016-12-03',
      '2017-03-11',
      '2017-03-27',
      '2017-03-31',
      '2017-05-04',
      '2017-05-25',
      '2017-09-05',
      '2017-09-30',
      '2017-12-23',
      '2017-12-24',
      '2017-12-25',
      '2018-01-20',
      '2018-04-27',
      '2018-04-28',
      '2018-04-29',
      '2018-04-30',
      '2019-05-12',
    ],
    engagement: [
      'engagement-photo-1',
      'engagement-photo-2',
      'engagement-photo-3',
      'engagement-photo-4',
      'engagement-photo-5',
      'engagement-photo-6',
      'engagement-photo-7',
      'engagement-photo-8',
      'engagement-photo-9',
      'engagement-photo-10'
    ]
  };
  // private imageNames: string[] = [
  //   '2014-05-22',
  //   '2015-03-22',
  //   '2015-03-28',
  //   '2015-05-02',
  //   '2015-10-24',
  //   '2015-11-14',
  //   '2016-03-12',
  //   '2016-05-28',
  //   '2016-07-06',
  //   '2016-10-25',
  //   '2016-12-03',
  //   '2017-03-11',
  //   '2017-03-27',
  //   '2017-03-31',
  //   '2017-05-04',
  //   '2017-05-25',
  //   '2017-09-05',
  //   '2017-09-30',
  //   '2017-12-23',
  //   '2017-12-24',
  //   '2017-12-25',
  //   '2018-01-20',
  //   '2018-04-27',
  //   '2018-04-28',
  //   '2018-04-29',
  //   '2018-04-30',
  //   '2019-05-12',
  // ];
}
